export { default as AuthModal } from "src/molecules/AuthModal/AuthModal";
